import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_108_8974)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19.0556 3H4.88889C3.85 3 3 3.85 3 4.88889V18.1111C3 19.15 3.85 20 4.88889 20H19.0556C20.0944 20 20.9444 19.15 20.9444 18.1111V4.88889C20.9444 3.85 20.0944 3 19.0556 3ZM19.0556 4.88889V7.72222H4.88889V4.88889H19.0556ZM14.3333 18.1111H9.61111V9.61111H14.3333V18.1111ZM4.88889 9.61111H7.72222V18.1111H4.88889V9.61111ZM16.2222 18.1111V9.61111H19.0556V18.1111H16.2222Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_108_8974",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}) })]
});
export default SvgTableChart;
